import DOMPurify from './dompurify-proxy';

export function sanitizeHref(url) {
  const sanitized = DOMPurify.sanitize(`<a href="${url}"></a>`, { ALLOWED_TAGS: ['a'], ALLOWED_ATTR: ['href'] });
  const match = sanitized.match(/href="([^"]*)"/);
  return match ? match[1] : '';
}
